import { Box } from '@chakra-ui/react';
import React, { useContext } from 'react';
import { commonStyle } from '../common/styles';
import { MasterContext } from '../context/MasterContextProvider';
import { WindowSizeContext } from '../context/WindowSizeContextProvider';

const WIDTH = 280;
const HEIGHT = 170;

const MESSAGE =
  '情報が取得できません。\nしばらくしてから\n再度アクセスしてください。\n\n';
const MESSAGE_EN = 'Failed to get information.\nPlease try again later.';

const Loading: React.FC = () => {
  const { size } = useContext(WindowSizeContext);
  const { failedGetMaster } = useContext(MasterContext);

  return (
    <>
      <Box
        w={size.w}
        h={size.h}
        bgColor='black'
        color='white'
        fontSize='32px'
        fontWeight='bold'
        sx={{ ...commonStyle.center }}
      >
        {!failedGetMaster ? (
          'Loading...'
        ) : (
          <Box
            w={WIDTH}
            h={HEIGHT}
            top={`calc(50% - ${HEIGHT / 2})`}
            left={`calc(50% - ${WIDTH / 2}px)`}
            position='fixed'
            fontSize={'16px'}
            border='solid 3px #FFC000'
            borderRadius='20px'
            padding='5px 10px'
            sx={{ ...commonStyle.center }}
            wordBreak='break-word'
            whiteSpace='pre-wrap'
          >
            {MESSAGE}
            {MESSAGE_EN}
          </Box>
        )}
      </Box>
    </>
  );
};

export default React.memo(Loading);
